Function.prototype.ToString = function () { return this.toString(); }